const translations = {
    'wildlife.byAge': 'Dzika zwierzyna wg wieku',
    'wildlife.none': 'Brak zwierzyny.',
    'wildlife.section': 'Dzika zwierzyna',
    'wildlife.total': 'Dzika zwierzyna razem: %d',
};

export default translations;
